export default [

  // 登录
  {
    path: '/',
    name: 'login',
    meta: { title: '门户网站' },
    component: () => import('@/pages/login/index'),
  },

  // 404
  {
    path: '/:pathMatch(.*)*', 
    name: '404',
    meta: { title: '门户网站' },
    component: () => import('@/pages/login/404'), 
  },

  // 唤起微信小程序
  {
    path: '/wechat/miniprogram', 
    name: 'wechatMiniprogram',
    meta: { title: '门户网站' },
    component: () => import('@/pages/login/wechatMiniprogram'), 
  },
  
]